import React from "react";
import "./index.scss";
export const CheckBox = ({ checked, isDisabled, text, onChange, style }) => {
  return (
    <div className="wrapper-checkbox" style={style}>
      <label className="check-box-container">
        <input
          type="checkbox"
          style={{ marginRight: 8 }}
          checked={checked}
          onChange={onChange}
          disabled={isDisabled}
        />
        <span
          className={
            isDisabled ? "checkbox-checkmark-all" : "checkbox-checkmark"
          }
        ></span>
      </label>
      <span className={isDisabled ? "label-disabled" : "label-enable"}>
        {text}
      </span>
    </div>
  );
};
